import { render, staticRenderFns } from "./PaymentBreakdown.vue?vue&type=template&id=dd60d36a"
import script from "./PaymentBreakdown.vue?vue&type=script&lang=js"
export * from "./PaymentBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports